/** Sub-case of an AgentPresenceState, driving line2 copy and the CTA label. Spans two source systems on purpose — delegation
 *  status/blockedReason and executor attention/prepared-plan — because both can put an
 *  agent "on" a DoBox and the card renders one vocabulary regardless of which one fired. */
export enum AgentPresenceVariant {
  WORKING = 'WORKING',
  WAITING_FOR_DEVICE = 'WAITING_FOR_DEVICE',
  WAITING_REPLY = 'WAITING_REPLY',
  QUESTION = 'QUESTION',
  NEEDS_INPUT = 'NEEDS_INPUT',
  NEEDS_CONNECTION = 'NEEDS_CONNECTION',
  SEND_FAILED = 'SEND_FAILED',
  PLAN_READY = 'PLAN_READY',
  PAUSED = 'PAUSED',
  FAILED = 'FAILED',
  APPROVAL = 'APPROVAL',
  DRAFT_READY = 'DRAFT_READY',
  EDIT_APPROVAL = 'EDIT_APPROVAL',
  PR_READY = 'PR_READY',
}
